import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import BarraBotones   from '../../components/Barra_menu';
import {withStyles} from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import DialogContent          from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {virtual} from '../../components/VirtualListBox';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import {Table, Grid, TableTreeColumn, TableHeaderRow, TableFixedColumns, TableSelection, TableFilterRow} from '@devexpress/dx-react-grid-material-ui';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import Slide from '@material-ui/core/Slide';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import PersonIcon from '@material-ui/icons/Person';
import VideocamIcon from '@material-ui/icons/Videocam';
import { createStore } from 'redux';
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import Popper from '@material-ui/core/Popper';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Fade from '@material-ui/core/Fade';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import CheckIcon from '@material-ui/icons/Check';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let planes = [];
let checkId = undefined;
let checkIdCo = undefined;

const styles = theme => ({

paper: { 
  borderRadius: globales.border_dialog,
}, 
paperConfirm: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},	
paperCo: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '1024px' : undefined, 
  maxWidth: !movil ? '1024px' : undefined,
  minHeight: !movil ? '570px' : undefined, 
  maxHeight: !movil ? '570px' : undefined,
},
paperCambio: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '500px' : "98%", 
  maxWidth: !movil ? '500px' : "98%", 
},
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
 display: 'flex',
 justifyContent: !movil ? 'center' : undefined, 
 alignItems: "center",
 flexDirection: !movil ? "row" : "column",
 paddingTop: "2px",
 paddingBottom: "5px", 
 paddingLeft: theme.spacing(1),
 paddingRight: theme.spacing(1)
},
textField: {
 marginRight: !movil ? theme.spacing(1) : undefined      
},
tooltip: {
  maxWidth: !movil ? 'none' : undefined,
},
popper: {
  zIndex: 1,
  '&[x-placement*="bottom"] $arrow': {
    top: 0,
    left: 0,
    marginTop: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '0 1em 1em 1em',
      borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
    },
  },
  '&[x-placement*="top"] $arrow': {
    bottom: 0,
    left: 0,
    marginBottom: '-0.9em',
    width: '3em',
    height: '1em',
    '&::before': {
      borderWidth: '1em 1em 0 1em',
      borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
    },
  },
  '&[x-placement*="right"] $arrow': {
    left: 0,
    marginLeft: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 1em 1em 0',
      borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
    },
  },
  '&[x-placement*="left"] $arrow': {
    right: 0,
    marginRight: '-0.9em',
    height: '3em',
    width: '1em',
    '&::before': {
      borderWidth: '1em 0 1em 1em',
      borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
    },
  },
},
arrow: {
  position: 'absolute',
  fontSize: 7,
  width: '3em',
  height: '3em',
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid',
  },
},
smallAvatar: {
  width: theme.spacing(3),
  height: theme.spacing(3),
},
paperTitle: { 
  height: '40px', 
  textAlign: 'center',
  verticalAlign: 'middle',
  lineHeight: '40px',
  margin: "1px " + globales.tabla.marginright + "px 0px " + globales.tabla.marginleft + "px", 
},
divSecondary: {
  marginBottom: '10px'
},

});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
  { name: 'ROOT_TREE', title: ' '},
  {name: 'ID_SECCION_CLIENTE', title: 'ID_SECCION_CLIENTE'},
  {name: 'CODIGO_CURSO', title: 'Código'},
  {name: 'DESCRIPCION_CURSO', title: 'Descripción'},
  {name: 'MODALIDAD', title: 'Grupo'},
  {name: 'CREDITOS', title: 'Uv'},
  {name: 'SECCION_DIAS', title: 'Dias'},
  {name: 'INICIO', title: 'Desde'},
  {name: 'FIN', title: 'Hasta'},
  {name: 'ESTATUS_SECCION', title: 'Estado sección'},
  {name: 'TIENE_SIN_COSTO', title: 'Sin costo'},
  {name: 'VALOR', title: 'Valor'},
  {name: 'DESCRIPCION_NIVEL', title: 'DESCRIPCION_NIVEL'},
  { name: 'TREE', title: ' ' },
];
const columnExtensions = [
  { columnName: 'ROOT_TREE', width: 100 },
  { columnName: 'CODIGO_CURSO', width: widthTable * 0.07 },
  { columnName: 'DESCRIPCION_CURSO', width: !movil ? widthTable * 0.24 : 280},
  { columnName: 'MODALIDAD', width: widthTable * 0.08, align: 'center'}, 
  { columnName: 'CREDITOS', width: widthTable * 0.05, align: 'center'},
  { columnName: 'SECCION_DIAS', width: widthTable * 0.06, align: 'center'}, 
  { columnName: 'INICIO', width: widthTable * 0.06, align: 'center'},
  { columnName: 'FIN', width: widthTable * 0.06, align: 'center'},    
  { columnName: 'AULA', width: widthTable * 0.06, align: 'center'}, 
  { columnName: 'ESTATUS_SECCION', width: widthTable * 0.09, align: 'center'}, 
  { columnName: 'TIENE_SIN_COSTO', width: widthTable * 0.06, align: 'center'}, 
  { columnName: 'VALOR', width: widthTable * 0.07, align: 'center'},
  { columnName: 'ID_SECCION_CLIENTE', width: 0},
  { columnName: 'TREE', width: 0},
  { columnName: 'DESCRIPCION_NIVEL', width: 0},
];
const grouping = [{ columnName: 'DESCRIPCION_NIVEL' }];

const settingFilter = [

  { columnName: 'VALOR',
     predicate: (value, filter, row) => {
                value = funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'INICIO',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value;
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'FIN',
     predicate: (value, filter, row) => {
                value = value !== null ? funciones.getTime(value, 1) : value;
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'ESTATUS_SECCION',
     predicate: (value, filter, row) => {
                value = value === "A" ? "Activa" : value === "C" ? "Cancelada" : "Desconocido";
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
  { columnName: 'TIENE_SIN_COSTO',
    predicate: (value, filter, row) => {
                value = value === 1 ? "Si" : value === 0 ? "No" : "-";
                return IntegratedFiltering.defaultPredicate(value, filter, row);
              },
  },

];

const columnsOferta = [
  { name: 'ROOT_TREE', title: ' '  },
  { name: 'ID_SECCION', title: 'ID_SECCION' },
  { name: 'CODIGO_CURSO', title: 'Código' },
  { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
  { name: 'CREDITOS', title: 'Uv' },
  { name: 'DIAS', title: 'Dias' },
  { name: 'INICIO', title: 'Desde' },
  { name: 'FIN', title: 'Hasta' },
  { name: 'AULA', title: 'Aula' },
  { name: 'NUMERO_SECCION', title: 'Sección' },
  { name: 'MODALIDAD', title: 'Grupo' },
  { name: 'PERIODO', title: 'Período' },
  { name: 'DISPONIBLE', title: 'Cupos' }, 
  { name: 'ID_PLAN', title: 'ID_PLAN' },
  { name: 'ESTATUS_FINANCIERO', title: 'Financiero' },
  { name: 'NOMBRE_COMPLETO', title: 'Catedrático' },
  { name: 'GRUPO', title: 'Referencia' },
  { name: 'OPTATIVA', title: 'OPTATIVA' },
  { name: 'TREE', title: ' ' },
];
const columnExtensionsOferta = [
  { columnName: 'ROOT_TREE', width: 100 },
  { columnName: 'CODIGO_CURSO', width: widthTable * 0.06 },
  { columnName: 'DESCRIPCION_CURSO', width: !movil ? widthTable * 0.16 : 280}, 
  { columnName: 'CREDITOS', width: widthTable * 0.05, align: 'center'},
  { columnName: 'DIAS', width: widthTable * 0.06, align: 'center'}, 
  { columnName: 'INICIO', width: widthTable * 0.06, align: 'center'},
  { columnName: 'FIN', width: widthTable * 0.06, align: 'center'},    
  { columnName: 'AULA', width: widthTable * 0.06, align: 'center'},    
  { columnName: 'NUMERO_SECCION', width: widthTable * 0.05, align: 'center'},   
  { columnName: 'MODALIDAD', width: widthTable * 0.07, align: 'center'},  
  { columnName: 'DISPONIBLE', width: widthTable * 0.06, align: 'center'},      
  { columnName: 'NOMBRE_COMPLETO', width: !movil ? widthTable * 0.13 : 250},
  { columnName: 'ID_SECCION', width: 0 },
  { columnName: 'ID_PLAN', width: 0 },
  { columnName: 'ESTATUS_FINANCIERO', width: 100 },
  { columnName: 'GRUPO', width: 0 },
  { columnName: 'OPTATIVA', width: 0 },
  { columnName: 'TREE', width: 0 }, 
  { columnName: 'PERIODO', width: 0 },
];
const groupingOferta = [{ columnName: 'ID_PLAN' }, { columnName: 'PERIODO' }];

const columnsCo= [
 { name: 'ID_SECCION', title: 'ID_SECCION' },
 { name: 'CODIGO_CURSO', title: 'Código' },
 { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
 { name: 'DIAS', title: 'Dias' },
 { name: 'INICIO', title: 'Desde' },
 { name: 'FIN', title: 'Hasta' },
 { name: 'AULA', title: 'Aula' },
 { name: 'NUMERO_SECCION', title: 'Sección' },
 { name: 'MODALIDAD', title: 'Grupo' },
 { name: 'DISPONIBLE', title: 'Cupos' },
 { name: 'NOMBRE_COMPLETO', title: 'Catedrático' },
];
const columnExtensionsCo = [
  { columnName: 'CODIGO_CURSO', width: 60 },
  { columnName: 'DESCRIPCION_CURSO', width: 230 }, 
  { columnName: 'DIAS', width: 60, align: 'center'}, 
  { columnName: 'INICIO', width: 80, align: 'center'},
  { columnName: 'FIN', width: 80, align: 'center'},    
  { columnName: 'AULA', width: 70, align: 'center'},    
  { columnName: 'NUMERO_SECCION', width: 64, align: 'center'}, 
  { columnName: 'MODALIDAD', width: 75, align: 'center'},   
  { columnName: 'DISPONIBLE', width: !movil ? 75 : 100, align: 'center'},      
  { columnName: 'NOMBRE_COMPLETO', width: !movil ? 110 : 180},
];

const columnsCambio = [
  { name: 'LABEL', title: 'Label' },
  { name: 'VALUE', title: 'Value' },
];
const columnExtensionsCambio = [
  { columnName: 'LABEL', width: "45%", wordWrapEnabled: true },
  { columnName: 'VALUE', wordWrapEnabled: true } 
];

const RowId = row => row.ID_SECCION_CLIENTE;
const RowIdOferta = row => String(row.ID_SECCION);
const ChildRows = (row, rootRows) => (row ? row.TREE : rootRows);
const GroupCellContent = ({ column, row }) => {
  return(
  <span>    
    <strong>{row.value}</strong> 
  </span>
  );
}
const GroupCellContentOferta = ({ column, row }) => {
  const infoPLan = planes.find(x => x.ID_PLAN === row.value);
  return(
  <span>    
    <strong> {column.name === 'ID_PLAN' ? (infoPLan !== undefined ? infoPLan.DESCRIPCION_NIVEL : " ") : 'Período ' + row.value} </strong> 
  </span>
  );

}
const VirtualTable_cellComponent = (changeOptionCost, estado, checkId) => (props) => {  

  const styleCell = { color: props.row.ROOT_TREE === "NEW" ? colores.azul 
                             : props.row.ESTATUS_SECCION === "C" ? "red" : undefined}
  
  if (props.column.name === 'INICIO')
  {
    return ( <Table.Cell style={styleCell} {...props}>
              { props.row.INICIO !== null ? funciones.getTime(props.row.INICIO, 1) : null }
             </Table.Cell>);
  }
     
  if (props.column.name === 'FIN')
  {
    return ( <Table.Cell style={styleCell} {...props}>
             { props.row.FIN !== null ? funciones.getTime(props.row.FIN, 1) : null }
            </Table.Cell>);
  }
  
  if (props.column.name === 'ESTATUS_SECCION')
  {
    if (props.row.ESTATUS_SECCION === "C"){ 

     return (<Table.Cell style={{ ...styleCell, position: "relative", paddingTop: 0, paddingBottom: 0 }} {...props}>
              <Tooltip title="Se recomienda realizar cambio de curso" placement="top" PopperProps={{style:{zIndex:500000}}} arrow>
                <InfoIcon fontSize="small" style={{ position: "absolute", top: 2, right: 2, color: colores.color_disabled, cursor: "default" }} onClick={(e)=> e.stopPropagation()}/>
              </Tooltip>
              <span>Cancelada</span>
            </Table.Cell>);

    }

    return (<Table.Cell style={styleCell} {...props}>
            {props.row.ESTATUS_SECCION === "A" ? "Activa" : "Desconocido"}
            </Table.Cell>);

  }

  if (props.column.name === 'TIENE_SIN_COSTO'){  
    
    const _style = {...styleCell, textAlign: "center", paddingBottom: 0, paddingTop: 0 } 

    if (estado && props.row.ID_SECCION_CLIENTE === checkId){
      return (<Table.Cell style={{ ..._style, paddingLeft: 8}} {...props}>
                <CircularProgress size={22} color="secondary" style={{ marginTop: 2 }}/>
              </Table.Cell>);
    }

    if (props.row.ROOT_TREE !== "NEW"){
    return (<Table.Cell style={_style} {...props}> 
             <Checkbox checked={Boolean(props.row.TIENE_SIN_COSTO) || props.row.ESTATUS_SECCION === "C"} 
                       onClick={changeOptionCost(props.row.ID_SECCION_CLIENTE, parseInt(props.row.TIENE_SIN_COSTO))}
                       disabled={(props.row.TREE !== null || !props.row.TIENE_PERMISO_SINCOSTO || props.row.ESTATUS_SECCION === "C") ? true : false}
                       style={{ width: 26, height: 26, marginTop: 0 }}/>
            </Table.Cell>);
    }

    return(<Table.Cell {...props}>{" "}</ Table.Cell>);

  }

  if (props.column.name === 'VALOR')
  {
    return (<Table.Cell style={styleCell} {...props}>
            {props.row.VALOR !== null ? funciones.formatCurrency(props.row.VALOR) : props.row.VALOR}        
           </ Table.Cell>
           );
  }
  
  return (<Table.Cell style={styleCell} {...props}/>);
       
 }
const HeaderRowCellComponent = ({resizingEnabled, ...props}) => {
 
const style={paddingTop: "5px", paddingBottom: "5px"}

if (props.column.name === "ROOT_TREE") {
  return (<TableHeaderRow.Cell resizingEnabled={false} style={{...style, left: 0}} {...props} />);
}

return (<TableHeaderRow.Cell resizingEnabled={resizingEnabled} {...props} />);

}
const FilterCellComponent = ({children, filteringEnabled, onFilter, getMessage, others, ...props})=>{ 
  
  if (props.column.name === "ROOT_TREE"){
    return (<Table.StubCell style={{ paddingTop: 0, paddingBottom: 0 }} {...props} />);
  }

  return (<TableFilterRow.Cell children={children} 
                               getMessage={getMessage}
                               filteringEnabled={filteringEnabled}
                               onFilter={onFilter}
                               {...props} />);
}
const TableTreeColumn_cellComponent = (estado, checkId, classTooltip, visibleOferta, visibleOfertaCo) => ({style, ...props}) => {
  const styleCell = {...style, paddingTop: 0, paddingBottom: 0 }

  if (props.row.ROOT_TREE === "NEW"){
    return (<TableTreeColumn.Cell style={{...styleCell, paddingLeft: "45px" }} {...props}>
             <Tooltip title={"Cambiar por " + props.row.DESCRIPCION_CURSO} placement="top" classes={{ tooltip: classTooltip }}> 
              <SubdirectoryArrowRightIcon style={{ color: colores.naranja }}/>
             </ Tooltip>
            </TableTreeColumn.Cell>);
  }

  if (estado && !visibleOferta && !visibleOfertaCo && props.row.ID_SECCION_CLIENTE === checkId)
  {  
    return (<TableTreeColumn.Cell style={{ ...styleCell, paddingLeft: "37px", paddingRight: 0}} {...props}>
                <CircularProgress size={22} color="secondary"/>
             </ TableTreeColumn.Cell>) 
  }

  return (<TableTreeColumn.Cell style={styleCell} {...props} />);
}
const tableTreeColumn_cellComponentOferta = (estado, checkId, classes, handleClickOption, rowOrigen) => ({children, style, ...props}) => {
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [arrowRef, setArrowRef] = React.useState(null);
  
  const styleCell = {...style, paddingTop: 0, paddingBottom: 0 } 
         
  const newChildren = React.Children.map(children, (child, index) => {
    
    if (index === 0){
      return React.cloneElement(child, { 
        ...child.props,
        level: (child.props.level === 1 && props.row.HDR === 0) ? 0 : child.props.level === 2 ? 1 : child.props.level
      });
    }

   if (index === 2){
    return (
      props.row.HDR === 1 || props.row.OPTATIVA === 1?
      <Checkbox icon={<span style={{ width: 0, height: 0 }} />} checkedIcon={<CheckIcon/>} disabled checked={(props.row.CHECKED || (props.row.CHECKED===1))}/>
      :
      React.cloneElement(child, { 
      ...child.props,
      disabled: (props.row.OPTATIVA === 1 || 
                 (props.row.ESTATUS_FINANCIERO !== "T" && props.row.ESTATUS_FINANCIERO !== "W" && props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0 && props.row.ID_ESTADO_MODALIDAD !== 2)) || 
                  props.row.HDR === 1
                 ? true : false
    })
    );
   }

   return child;
  });

  if (props.row.ROOT_TREE === "..." || (estado && String(props.row.ID_SECCION) === checkId))
  {  
    return (<TableTreeColumn.Cell style={{ ...styleCell, paddingLeft: props.row.ROOT_TREE !== "..." ? newChildren[0].props.level === 0 ? "37px" : "62px" 
                                                                                                    : undefined, 
                                  paddingRight: 0}} 
                                  {...props}>
                <CircularProgress size={22} color="secondary"/>
             </ TableTreeColumn.Cell>) 
  }
  
  if (props.row.ID_ESTADO_MODALIDAD === 2){

    const id_seccion_origen = rowOrigen !== undefined ? rowOrigen.ID_SECCION : 0; 

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget); 
    }
    
    const handleMenuClose = (value, idRow) => async (e)=>{
      await Promise.resolve(setAnchorEl(null));
      if (value !== null)
       handleClickOption(value, idRow); 
    }
        
    return (<TableTreeColumn.Cell style={{ ...style, paddingLeft: newChildren[0].props.level === 0 ? "35px" : "59px", paddingTop: 0, paddingBottom: 0 }} {...props}>
              <Checkbox onClick={handleClick} checked={false} id={String(props.row.ID_SECCION)} />              
              <Dialog open={Boolean(anchorEl)} hideBackdrop />
              <Popper id={String(props.row.ID_SECCION)} 
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement="top"
                      modifiers={{ arrow: { enabled: true, element: arrowRef }, }}
                      style={{ zIndex: 500000 }}
                      className={classes.popper}>
                <Fade in={Boolean(anchorEl)} timeout={350}>
                <Paper elevation={10}> 
                <ClickAwayListener onClickAway={handleMenuClose(null, null)} mouseEvent='onMouseDown' touchEvent='onTouchStart'>
                   <MenuList>
                   <MenuItem onClick={handleMenuClose("PRE", String(props.row.ID_SECCION))} disabled={id_seccion_origen === parseInt(String(props.row.ID_SECCION).split("-")[0]) && ((props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) || (props.row.AUTONOMA !== 2 && (props.row.HIBRIDA === 0 || !props.row.HIBRIDA))) ? true : false}>
                    <ListItemIcon style={{maxWidth: "40px", minWidth: "40px" }}><Avatar className={classes.smallAvatar} ><PersonIcon fontSize="small"/></Avatar></ListItemIcon>
                    <Typography>Presencial</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose("PMV", String(props.row.ID_SECCION))} disabled={id_seccion_origen === parseInt(String(props.row.ID_SECCION).split("-")[0]) && ((props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 0 || !props.row.HIBRIDA)) || (props.row.AUTONOMA !== 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA))) ? true : false}>
                    <ListItemIcon style={{maxWidth: "40px", minWidth: "40px" }}><Avatar className={classes.smallAvatar}><VideocamIcon fontSize="small"/></Avatar></ListItemIcon>
                    <Typography>PMV</Typography>
                  </MenuItem>
                   </MenuList>
                 </ClickAwayListener> 
                 <span className={classes.arrow} ref={setArrowRef} /> 
                </Paper>
                </Fade>
              </Popper>
            </TableTreeColumn.Cell>);
  }

  return (<TableTreeColumn.Cell children={newChildren} style={styleCell} {...props} />);
  
}
const VirtualTable_cellComponentOferta = (classTooltip) => (props) => {  

  const style={ color: ((props.row.CHECKED || props.row.CHECKED === 1) && props.row.ID_ESTADO_MODALIDAD !== 2) ? colores.azul : undefined, 
                fontWeight: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 'bold' : undefined,
                paddingTop: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 0 : undefined, 
                paddingBottom: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 0 : undefined}

  if (props.column.name === 'INICIO')
  {
    return ( <Table.Cell style={style} {...props}>
              { props.row.INICIO !== null ? funciones.getTime(props.row.INICIO, 1) : null }
             </Table.Cell>);
  }
     
  if (props.column.name === 'FIN')
  {
    return ( <Table.Cell style={style} {...props}>
             { props.row.FIN !== null ? funciones.getTime(props.row.FIN, 1) : null }
            </Table.Cell>);
  }
      
  if (props.column.name === 'DISPONIBLE')
  { 
     const colorIconChecked = colores.naranja;
     const _styleCell = {...style, paddingTop: 0, paddingBottom: 0}
     const styleIco = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ? colorIconChecked : colores.color_disabled} 
     const styleDiv = { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2px", maxHeight: "100%", width: "100%" }; 
     const styleIcoHibridaPre = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ?
                                        (props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) ? colorIconChecked
                                        : colores.color_disabled
                                       : colores.color_disabled }
     const styleIcoHibridaPmv = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ?
                                        (props.row.AUTONOMA === 2 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) ? colorIconChecked
                                        : colores.color_disabled
                                      : colores.color_disabled }

    if (props.tableRow.row.ID_ESTADO_MODALIDAD === 2){
      
     return (<Table.Cell style={_styleCell} {...props}>
             <div style={styleDiv}>
             {props.row.AUTONOMA === 2 ? props.row.DISPONIBLE_MODALIDAD : props.row.DISPONIBLE}
             <Tooltip title="Cupos Presencial" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
              <PersonIcon style={styleIcoHibridaPre} fontSize="small"/>
             </ Tooltip>
             {"  |  " + (props.row.AUTONOMA === 2 ? props.row.DISPONIBLE : props.row.DISPONIBLE_MODALIDAD)}
             <Tooltip title="Cupos Por Videoconferencia" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
              <VideocamIcon style={styleIcoHibridaPmv} fontSize="small"/>
             </ Tooltip>
             </ div>
            </Table.Cell>);

    }

    if ((props.tableRow.row.ID_ESTADO_MODALIDAD === 1 && props.tableRow.row.AUTONOMA === 1) || (props.tableRow.row.ID_ESTADO_MODALIDAD === 3 && props.tableRow.row.AUTONOMA === 2)){
        return (<Table.Cell style={_styleCell} {...props}>
                 <div style={styleDiv}>
                 {props.row.DISPONIBLE}
                 <Tooltip title="Cupos Presencial" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
                    <PersonIcon style={styleIco} fontSize="small"/>
                 </ Tooltip>
                 </div>
                </Table.Cell>);
    }

    if ((props.tableRow.row.ID_ESTADO_MODALIDAD === 1 && props.tableRow.row.AUTONOMA === 2) || (props.tableRow.row.ID_ESTADO_MODALIDAD === 3 && props.tableRow.row.AUTONOMA === 1)){
      return (<Table.Cell style={_styleCell} {...props}>
               <div style={styleDiv}>
               {props.row.DISPONIBLE}
              <Tooltip title="Cupos Por Videoconferencia" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
               <VideocamIcon style={styleIco} fontSize="small"/>
              </ Tooltip>
              </div>
             </Table.Cell>);
    }


  }

  if (props.column.name === 'NUMERO_SECCION' && props.row.HDR === 0 && props.row.OPTATIVA !== 1 && props.row.ESTATUS_FINANCIERO !== undefined && ((props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0) || !funciones.isEmpty(props.row.GRUPO)))
  {  
     var estado = props.row.ESTATUS_FINANCIERO === "T" ? "Prematriculado" : 
                    props.row.ESTATUS_FINANCIERO === "P" ? "Matriculado" :
                    props.row.ESTATUS_FINANCIERO === "W" ? "En lista de espera" :
                    props.row.ESTATUS_FINANCIERO === "X" ? "Congelado" : "Desconocido";
        estado = props.row.ID_ESTADO_MODALIDAD === 2 ? 
                  (props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) ? estado + " (Presencial)" :  
                  (props.row.AUTONOMA === 2 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) ? estado + " (Por Videoconferencia)" : estado
                 : estado;

     var title = props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0 ? "Estado\n" + estado : "";  
         title = title + (title.length > 0 && !funciones.isEmpty(props.row.GRUPO) ? "\n\n" : "") + (!funciones.isEmpty(props.row.GRUPO) ? "Grupo\n" + props.row.GRUPO : "");
         
    return (<Table.Cell style={{ ...style, position: "relative" }} {...props}>
              <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{title}</ span>} placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}} arrow>
                <MoreHorizIcon fontSize="small" style={{ position: "absolute", top: 0, right: 10, color: colores.color_disabled, cursor: "default" }} onClick={(e)=> e.stopPropagation()}/>
              </Tooltip>
              <span>{props.row.NUMERO_SECCION}</span>
            </Table.Cell>);
  }

  if (props.column.name === "CREDITOS" && props.row.HDR === 1)
  { 
    return (<Table.Cell style={style} {...props}>
            <span>{null}</span> 
            </Table.Cell>);
  }

  return (<Table.Cell style={style} {...props}/>);
       
}
const Table_cellComponentCambio = ({style, value, ...props}) => {

const styleCell = { border: "none", paddingBottom: 12 }

if (props.column.name === "LABEL"){
  return (<Table.Cell value={value} 
                      style={{ ...styleCell, fontWeight: "bold"}}
          {...props}/>);
}

if (props.column.name === "VALUE" && props.row.KEY > 18){
  
  const cellNumeric = { height: "100%", width: "50px", textAlign: "right"}

  if (props.row.KEY === 23 && parseFloat(value) > 0){
    return (<Table.Cell style={{ ...styleCell, fontWeight: "bold", paddingTop: "2px", paddingBottom: "2px"}} {...props}>
      <div style={{display: "flex", alignItems: "center"}}>
      <div style={{...cellNumeric}}>
       {value}
      </ div>
      <Tooltip title="Para que el cambio tenga efecto debe pagar la factura en Financiero" 
                PopperProps={{style:{zIndex:500000}}}
                placement="top"
                arrow>
         <WarningIcon style={{ marginLeft: "16px", color: colores.tabla.color_iconos_SL_ }}/>
        </ Tooltip>
      </ div>
     </Table.Cell>);
  }

  return (<Table.Cell style={{...styleCell, ...cellNumeric, fontWeight: props.row.KEY === 23 ? "bold" : undefined}} {...props}>
           <div style={cellNumeric}>{value}</ div>
          </Table.Cell>);

}

return (<Table.Cell value={value} style={styleCell} {...props}/>);
 
}
const tableSelectionCellComponent = (estado, checkId, classes, handleClickOption, rowOrigen) => ({style, ...props}) =>{
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [arrowRef, setArrowRef] = React.useState(null);

  if (estado && String(props.row.ID_SECCION) === checkId)
  {
   return ( <Table.Cell style={{ ...style, paddingLeft: '20px', paddingTop: "2px", paddingBottom: "0px" }} {...props}>
             <CircularProgress size={22} color="secondary"/>
           </Table.Cell> 
          );
  }  
  
  if (props.row.ID_ESTADO_MODALIDAD === 2){

    const id_seccion_origen = rowOrigen !== undefined ? rowOrigen.ID_SECCION : 0;

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget); 
    }
    
    const handleMenuClose = (value, idRow) => async (e)=>{
      await Promise.resolve(setAnchorEl(null));
      if (value !== null)
       handleClickOption(value, idRow); 
    }
    
    return (<Table.Cell style={{ ...style, paddingLeft: "18px", paddingTop: 0, paddingBottom: 0, paddingRight: 0 }} {...props}>
              <Checkbox onClick={handleClick} checked={false} id={String(props.row.ID_SECCION)} />
              <Dialog open={Boolean(anchorEl)} hideBackdrop />
              <Popper id={String(props.row.ID_SECCION)} 
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement="top"
                      modifiers={{ arrow: { enabled: true, element: arrowRef }, preventOverflow: { enabled: true, boundariesElement: 'scrollParent' }, }}
                      style={{ zIndex: 500000 }}
                      className={classes.popper}
                    > 
                <Fade in={Boolean(anchorEl)} timeout={350}>
                <Paper elevation={10}>
                <ClickAwayListener onClickAway={handleMenuClose(null, null)} mouseEvent='onMouseDown' touchEvent='onTouchStart'>             
                   <MenuList>
                   <MenuItem onClick={handleMenuClose("PRE", String(props.row.ID_SECCION))} disabled={id_seccion_origen === parseInt(props.row.ID_SECCION) && ((props.row.AUTONOMA === 2 && props.row.HIBRIDA) || (props.row.AUTONOMA !== 2 && !props.row.HIBRIDA)) ? true : false}>
                    <ListItemIcon style={{maxWidth: "40px", minWidth: "40px" }}><Avatar className={classes.smallAvatar} ><PersonIcon fontSize="small"/></Avatar></ListItemIcon>
                    <Typography>Presencial</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose("PMV", String(props.row.ID_SECCION))} disabled={id_seccion_origen === parseInt(props.row.ID_SECCION) && ((props.row.AUTONOMA === 2 && !props.row.HIBRIDA) || (props.row.AUTONOMA !== 2 && props.row.HIBRIDA)) ? true : false}>
                    <ListItemIcon style={{maxWidth: "40px", minWidth: "40px" }}><Avatar className={classes.smallAvatar}><VideocamIcon fontSize="small"/></Avatar></ListItemIcon>
                    <Typography>Por Videoconferencia</Typography>
                  </MenuItem>
                   </MenuList>
                 </ClickAwayListener> 
                 <span className={classes.arrow} ref={setArrowRef} /> 
                </Paper>    
                </Fade>
              </Popper>
            </Table.Cell>);
  }
  
  return ( <TableSelection.Cell style={style} {...props}/>);
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const reducer = (state, action) => {

  if (action.type === "SET_OPTATIVAS")
  {
    return {
      ...state,
      rowsOferta: action.current_rows.map(item => {            
              if (String(item.ID_SECCION) === action.id_seccion) { 
                return {...item, TREE: action.rows_optativas } 
              };
              return item;
            }),
     }
  
  }    
  
  if (action.type === "SET_NUEVA_SECCION"){

    return {
      ...state,
      rows: action.current_rows.map(item => {
        if (item.ID_SECCION_CLIENTE === action.id_seccion_cliente) {
          return {...item, TREE: action.new_row }
        }
        return item;
      })
    }

  }

  return state;
  
}
const ColumnFixed_cellComponent = ({showLeftDivider, showRightDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell {...props}>
              <div style={{ background: "white", height: "30px", width: "100%" }} />
             </TableFixedColumns.Cell>);
  }

  return (<TableFixedColumns.Cell 
           style={{ backgroundColor: 'inherit', paddingTop: 0, paddingBottom: 0 }}
           showRightDivider={false}
           showLeftDivider={false}
           {...props} 
       />);

}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
tablaOfertaRef = React.createRef();
dialogActionRef = React.createRef();
vtRef = React.createRef(); 

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       expandedGroups: [],
       expandedRowIds: [],
       openBackDropInvisible: false,
       optionAutocomplete: [],
       loadingClientes: true,
       valueAutoComplete: null,
       openAutoComplete: false,
       openModal: false,
       openModalConfirmation: false,
       openModalCo: false,
       selection: [],
       heightTableOferta: 0,
       heightTableOfertaCo: 0,
       rowsOferta: [],
       loadingOferta: false,
       expandedGroupsOferta: [],
       selectionOferta: [],
       expandedRowIdsOferta: [],
       loadingCheck: false,
       rowsCo: [],
       selectionCo: [],
       loadingOfertaCo: false,
       openModalCambio: false,
       rowsCambio: [],
       loadingCheckSecondary: false,
       totaldiferencia:0,
       nota:"Para que el cambio tenga efecto debe pagar la factura en Financiero.",
   };
   this.cuenta= null;
   this.reducerRows = createStore(reducer, { rowsOferta: [] });
   this.unsubscribeRows = this.reducerRows.subscribe(() => {
      this.setState({ rowsOferta: this.reducerRows.getState().rowsOferta });
    });
   this.reducerRowsNew = createStore(reducer, { rows: [] });
   this.unsubscribeRowsNew = this.reducerRowsNew.subscribe(() => {
    this.setState({ rows: this.reducerRowsNew.getState().rows });
  });
   this.electivasOpens=[];
   this.botones = [
                  {icono: 'Add', toolt: 'Agregar curso',    nombre: 'Agregar'   ,escritura:true, onclick: this.addEvent,  display: 'auto'},
                  {icono: 'Edit', toolt: 'Modificar curso', nombre: 'Modificar' ,escritura:true, onclick: this.editEvent,  display:'auto'},
                  {icono: 'Delete', toolt: 'Eliminar curso', nombre: 'Eliminar' ,escritura:true, onclick: this.deleteEvent, color: colores.naranja, display: 'auto'},  
                 ];
   this.botones_eliminar =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOk , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirmation, display:'auto', color: 'red'},
   ];
   this.botones_opciones_cambios =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleCSCOk , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirmation, display:'auto', color: 'red'},
   ];
   this.botones_cambio =[
    {icono: 'Check', toolt: '', nombre: 'Cambiar', onclick: this.handleCambioOk , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseCambio, display:'auto', color: 'red'},
   ];
   this.id_seccion_cliente = null;
   this.rowsCambioTmp=[];
   this.baseHibridaTmp=null;
   this.selectionNewTmp=[];
   this.selectionOldTmp=[];
   this.coHibridaTmp=null;
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
}
    
onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}
    
onChangeAutocomplete = (event, value) =>{

planes = []; 
this.setState({ valueAutoComplete: value, 
                openAutoComplete: false, 
                rows: [], 
                selection: [],
                expandedGroups: [],
                expandedRowIds: [] }, ()=>{
        
 if (value === null)
 {
   return;
 }
    
 this.handleChangeCuenta(null);   
        
});
    
}
  
filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/cambios/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 30000, deadline: 40000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

onRefresh = ()=>{
  
 this.setState({ loadingClientes: true }, ()=>{ 
   this.filtersClientes('-');
 });
       
}

obtener_planes = ()=>{

new Request
.get(`${globales.ip}/cambios/planes/${this.cuenta}/${tokenInfo.plataforma}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 30000, deadline: 40000, }) 
.end((err, res) => {
                
  if (err) { 
        
   if (err.toString().substr(0,16) === 'Error: Forbidden')
   {
    window.location.reload();
    return;
                      
   }
                
   funciones.showToast('e', 'No hay conexión');
                     
   return;
  }
              
  planes = JSON.parse(res.text).filter(x => x.ESTADO.trim() === 'ACTIVO'); 

});

}

handleChangeCuenta = (event) => {
        
this.cuenta = (event === null && tokenInfo.plataforma === 2) ? tokenInfo.user : tokenInfo.plataforma === 1 ? this.state.valueAutoComplete.CUENTA_ALUMNO : null;
this.setState({ loadingMain: true }, ()=>{ 
    
  this.obtener_planes();
    
  new Request
   .get(`${globales.ip}/cambios/oferta/${this.cuenta}/${tokenInfo.user}/${tokenInfo.sucursal}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(1)
   .timeout({ response: 50000, deadline: 60000, }) 
   .end((err, res) => {
            
      if (err) { 
    
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                
          window.location.reload();
          return;
                  
        }
    
        this.setState({ loadingMain: false}, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
      
        return;
       }
          
       const rows = JSON.parse(res.text);
       
       let allGroups = [];
       let foundGroup;
       let selection = [];

       rows.map((item)=>{
        foundGroup = allGroups.find(x => x === item.DESCRIPCION_NIVEL);
        if (foundGroup === undefined){
          allGroups.push(item.DESCRIPCION_NIVEL);
        }else {
          foundGroup = undefined;
        }

        if (item.CHECKED){
          selection.push(item.ID_SECCION_CLIENTE);
        }

        return item;
       }); 

       this.setState({ rows: this.formatRowsMain(rows), 
                       selection,
                       expandedGroups: allGroups, 
                       loadingMain: false });         
       
     });
           
   });
    
}

changeExpandedGroups = expandedGroups =>
{ 
  this.setState({ expandedGroups }); 
}

changeExpandedGroupsOferta = expandedGroupsOferta =>
{
  this.setState({ expandedGroupsOferta }); 
}

changeSelection = selection => {
 
 this.id_seccion_cliente = funciones.getIdRowChecking(selection, this.state.selection); 
 this.rowsCambioTmp=[];
 const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente);
 const markAction = selection.length > this.state.selection.length ? true : false;
 
 if (!markAction){
  this.setState({ confirmationTitle: "Reversar cambio",
                  confirmationText: "¿Desea reversar el cambio?",
                  openModalConfirmation: true });
  return;
 }

 this.setState({ rowsOferta: [],
                 expandedGroupsOferta: [],
                 selectionOferta: [],
                 expandedRowIdsOferta: [],
                 rowsCo: [],
                 selectionCo: [] }, ()=>{
                  
                 if (rowChecked.ES_CORREQUISITO){
                   this.setState({ loadingOfertaCo: true, openModalCo: true }, ()=>{
                     this.obtener_oferta_co(this.cuenta, rowChecked.ID_DETALLE_PLAN_BASE);
                   });
                   return;
                 }

                 this.setState({ loadingOferta: true, openModal: true }, ()=>{ 
                    this.electivasOpens=[];
                    this.obtener_oferta(this.cuenta);
                 });

              });
}

getInfoRowChecked=(id_seccion)=>{

  var row=[];

  this.state.rowsOferta.map((item)=>{

    if (item.TREE !== null)
    {
       item.TREE.map((_item)=>{
        
         if (_item.TREE !== null){
            _item.TREE.map((__item)=>{
              if (String(__item.ID_SECCION) === id_seccion){ 
                row=__item;
              }
              return __item;
            });
         }
  
        if (String(_item.ID_SECCION) === id_seccion)
        {  
          row=_item;
        }
  
        return _item;
       });
    }
  
    return  item;
  });

 return row;

}

changeSelectionOferta = (selectionOferta) => {
    
  checkId = funciones.getIdRowChecking(selectionOferta, this.state.selectionOferta); 
  const rowChecked = this.getInfoRowChecked(checkId);
  const rowCheckedOrigen = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente);
  
  if (rowChecked.CORREQUISITOS === 1 && rowChecked.CODIGO_CURSO !== rowCheckedOrigen.CODIGO_CURSO)
  { 
    this.selectionNewTmp = selectionOferta;
    this.selectionOldTmp = this.state.selectionOferta;
    this.setState({ loadingOfertaCo: true, rowsCo: [], openModalCo: true }, ()=>{
      this.obtener_oferta_co(this.cuenta, rowChecked.ID_DETALLE_PLAN); 
    });
    return;
  }

  this.setState({ loadingCheck: true }, ()=>{

    const id_seccion_destino = parseInt(String(rowChecked.ID_SECCION).split("-")[0]);
    const id_detalle_plan = String(rowChecked.ID_SECCION).split("-")[1] !== undefined ? parseInt(String(rowChecked.ID_SECCION).split("-")[1]) : 'null';
    
    this.gestion_cambio(rowCheckedOrigen.ID_PLAN, 
                        rowCheckedOrigen.ID_SECCION, 
                        rowCheckedOrigen.ES_CORREQUISITO,
                        rowCheckedOrigen.TIENE_CORREQUISITOS,
                        rowCheckedOrigen.HIBRIDA,
                        parseFloat(rowCheckedOrigen.VALOR).toFixed(2),
                        rowChecked.ID_PLAN, 
                        id_seccion_destino, 
                        'null', //id_seccion_co_nueva
                         0, //es_co_nueva
                         0, //tiene_co_nueva
                         this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp, 
                         this.baseHibridaTmp === 1 ? parseFloat(rowChecked.VALOR_MODALIDAD).toFixed(2): parseFloat(rowChecked.VALOR).toFixed(2), 
                         0, //hibrida_co_nueva
                         id_detalle_plan, 
                         3)
     .then((res)=>{
        
        if (res === null){
          this.resetValuesSeccionHibrida();
          return; 
        } 

        if (res[0].RESP === 'OK')
        {     
          this.handleClose(); 
          this.setState({ loadingCheck: false, 
                          rowsCambio: this.rowsCambio(rowCheckedOrigen.ID_PLAN,
                                                      rowCheckedOrigen.ID_SECCION,
                                                      rowCheckedOrigen.ES_CORREQUISITO,
                                                      rowCheckedOrigen.TIENE_CORREQUISITOS,
                                                      rowCheckedOrigen.HIBRIDA,
                                                      rowCheckedOrigen.VALOR,
                                                      rowChecked.ID_PLAN,
                                                      id_seccion_destino,
                                                      'null',
                                                      0,
                                                      0,
                                                      this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp,
                                                      this.baseHibridaTmp === 1 ? rowChecked.VALOR_MODALIDAD : rowChecked.VALOR,
                                                      0,
                                                      id_detalle_plan,
                                                      rowCheckedOrigen.DESCRIPCION_CURSO,
                                                      rowChecked.DESCRIPCION_CURSO,
                                                      res[0].CARGO_PAGAR,
                                                      res[0].MONTO_PAGAR), 
                          openModalCambio: true }, ()=> { 
                   
                          this.resetValuesSeccionHibrida(); });     

        }
        else
        {
          this.setState({ loadingCheck: false }, ()=> { 
            this.setValuesRow(checkId, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
              funciones.showToast('w', res[0].RESP); 
              this.resetValuesSeccionHibrida();
            });     

        }

      });

 });


}

changeSelectionCo = selectionCo => {

 checkIdCo = funciones.getIdRowChecking(selectionCo, this.state.selectionCo);

 const rowCheckedOrigen = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente);
 const rowChecked =  rowCheckedOrigen.ES_CORREQUISITO ? null : this.getInfoRowChecked(checkId);
 const rowCoChecked = this.state.rowsCo.find(x => x.ID_SECCION === parseInt(checkIdCo));
 
 let seccionBase = rowChecked !== null ? String(rowChecked.ID_SECCION).split("-") : null; 
 
 this.setState({ loadingCheck: true }, ()=>{ 
  
  const id_seccion_destino = seccionBase !== null ? seccionBase[0] : rowCoChecked.ID_SECCION;
  const id_detalle_plan = seccionBase !== null && seccionBase[1] !== undefined ? seccionBase[1] : 'null';
  const id_plan_origen = rowCheckedOrigen.ID_PLAN;
  const id_seccion_origen = rowCheckedOrigen.ID_SECCION;
  const es_correquisito = rowCheckedOrigen.ES_CORREQUISITO;
  const tiene_correquisitos = rowCheckedOrigen.TIENE_CORREQUISITOS;
  const hibrida = rowCheckedOrigen.HIBRIDA;
  const id_plan_nueva = rowChecked !== null ? rowChecked.ID_PLAN : rowCheckedOrigen.ID_PLAN;
  const id_seccion_co_nueva = rowChecked !== null ? rowCoChecked.ID_SECCION : 'null';
  const es_co_nueva = rowChecked !== null ? 0 : 1;
  const tiene_co_nueva = rowChecked !== null ? 1 : 0;
  const hibrida_nueva = rowChecked !== null ? (this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp) : (this.coHibridaTmp === null ? 0 : this.coHibridaTmp);
  const precio_nuevo =  rowChecked !== null ? (this.baseHibridaTmp === 1 ? parseFloat(rowChecked.VALOR_MODALIDAD).toFixed(2): parseFloat(rowChecked.VALOR).toFixed(2)) : "0.00";
  const hibrida_co_nueva = rowChecked !== null ? (this.coHibridaTmp === null ? 0 : this.coHibridaTmp) : 0;

  this.gestion_cambio(id_plan_origen, 
                      id_seccion_origen, 
                      es_correquisito,
                      tiene_correquisitos,
                      hibrida,
                      parseFloat(rowCheckedOrigen.VALOR).toFixed(2),
                      id_plan_nueva, 
                      id_seccion_destino, 
                      id_seccion_co_nueva, 
                      es_co_nueva, 
                      tiene_co_nueva, 
                      hibrida_nueva, 
                      precio_nuevo, 
                      hibrida_co_nueva, 
                      id_detalle_plan, 
                      3)
  .then((res)=>{

  if (res === null){
  this.resetValuesSeccionHibridaCo();
  return; 
  } 
  
  if (res[0].RESP === 'OK' && res[0].RESP_CORREQUISITO === 'OK')
  {
    this.handleCloseCo();     
    this.handleClose(); 
    this.setState({ loadingCheck: false, 
                    rowsCambio: this.rowsCambio(id_plan_origen,
                                                id_seccion_origen,
                                                es_correquisito,
                                                tiene_correquisitos,
                                                hibrida,
                                                rowCheckedOrigen.VALOR,
                                                id_plan_nueva,
                                                id_seccion_destino,
                                                id_seccion_co_nueva,
                                                es_co_nueva,
                                                tiene_co_nueva,
                                                hibrida_nueva,
                                                parseFloat(precio_nuevo),
                                                hibrida_co_nueva,
                                                id_detalle_plan,
                                                rowCheckedOrigen.DESCRIPCION_CURSO,
                                                rowChecked !== null ? rowChecked.DESCRIPCION_CURSO : rowCoChecked.DESCRIPCION_CURSO,
                                                res[0].CARGO_PAGAR,
                                                res[0].MONTO_PAGAR), 
        openModalCambio: true }, ()=> { 
    
          this.resetValuesSeccionHibrida();
          this.resetValuesSeccionHibridaCo();
        });     

  }
  else
  {
        this.setState({ loadingCheck: false }, ()=> { 
         this.setValuesRow(checkId, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
         this.setCheckedRowCo(checkIdCo, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO); 
         this.resetValuesSeccionHibridaCo(); 

         if (res[0].RESP !== 'OK')
         return funciones.showToast('w', res[0].RESP + " (Curso base)");
         
         funciones.showToast('w', res[0].RESP_CORREQUISITO + " (Correquisito)");

        });     

  }

  });


 });

}

handleClose = ()=>{
 this.setState({ openModal: false });
}

handleCloseCo = ()=>{
  checkIdCo = undefined;
  this.selectionNewTmp= [];
  this.selectionOldTmp= [];
  this.resetValuesSeccionHibrida();
  this.setState({ openModalCo: false });
}

onEntering = ()=>{
  this.setState({ heightTableOferta: funciones.getHeightTableDialog(movil, this.tablaOfertaRef, this.dialogActionRef, 2) });
}

onEnteringCo = ()=>{
 this.setState({ heightTableOfertaCo: funciones.getHeightTableDialog(movil, this.tablaOfertaRef, this.dialogActionRef, 2) });
}

obtener_oferta = (cuenta)=>{

new Request
.get(`${globales.ip}/cambios/matricula/${cuenta}/${tokenInfo.user}/${tokenInfo.sucursal}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 50000, deadline: 60000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ loadingOferta: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
      });
        
      return;
   }
      
   const rows = JSON.parse(res.text);

   if (rows.length > 0) 
   {    

      const infoTable = this.formatRows(rows);    
      this.setState({ rowsOferta: infoTable.rows, 
                      expandedGroupsOferta: infoTable.expandedGroup, 
                      selectionOferta: infoTable.selection, 
                      loadingOferta: false });

   }
   else 
   {
     this.setState({ loadingOferta: false });
   }            
   
});


}

obtener_oferta_co = (cuenta, id_detalle_plan) =>{

new Request
.get(`${globales.ip}/cambios/correquisito/${cuenta}/${id_detalle_plan}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 40000, deadline: 50000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ loadingOfertaCo: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
      });
  
      return;
   }
      
   const rows = JSON.parse(res.text);

   if (rows.length > 0)
   {    
    
    this.setState({ rowsCo: rows.filter(x => !x.CHECKED || x.ID_ESTADO_MODALIDAD === 2),
                    loadingOfertaCo: false });

   }
   else 
   {
    this.setState({ loadingOfertaCo: false });
   }            
   
});

}

formatRows = (rows)=>{

  const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente); 
  let _rows = rows.filter(x => (x.CHECKED === 0) || 
                               (x.CODIGO_CURSO === rowChecked.CODIGO_CURSO && (x.ID_SECCION !== rowChecked.ID_SECCION || x.ID_ESTADO_MODALIDAD === 2)) ||
                               (x.ID_SECCION === rowChecked.ID_DETALLE_PLAN_OPTATIVA)); 

  let parentRows = _rows.filter(x => (x.HDR === 1 || x.OPTATIVA === 1));
  
  parentRows.map((item, index)=>{
  
  item.TREE = item.OPTATIVA === 1 ? 
                [{ ROOT_TREE: "...",
                   ID_SECCION: index * -1, 
                   CODIGO_CURSO: null, 
                   DESCRIPCION_CURSO: null, 
                   CREDITOS: null, 
                   DIAS: null, 
                   INICIO: null, 
                   FIN: null,
                   AULA: null, 
                   NUMERO_SECCION: null,  
                   PERIODO: item.PERIODO, 
                   DISPONIBLE: null,  
                   ID_PLAN: item.ID_PLAN, 
                   ESTATUS_FINANCIERO: null, 
                   NOMBRE_COMPLETO: null, 
                   GRUPO: null,
                   OPTATIVA: 0, 
                   CHECKED: item.CHECKED,
                   TREE: null,
                   HDR: 1 }] :
                _rows.filter(x => x.CODIGO_CURSO === item.CODIGO_CURSO && x.HDR === 0);
  
  return item;
  
  });
  
  let allGroups = [];
  let foundPlan;
  let foundPeriodo;
  let selection = [];
  
  _rows.map((item, index)=>{
  
    foundPlan = allGroups.find(x => x === item.ID_PLAN.toString());
    if (foundPlan === undefined){
        allGroups.push(item.ID_PLAN.toString());
    }else {
        foundPlan = undefined;
    }
  
    foundPeriodo= allGroups.find(x => x === item.ID_PLAN + '|' + item.PERIODO);
    if (foundPeriodo === undefined){
       allGroups.push(item.ID_PLAN + '|' + item.PERIODO);
    }else {
      foundPeriodo = undefined;
    }
                               
    if (item.CHECKED && (item.HDR === 1 || item.OPTATIVA === 1))
    {
      selection.push(String(item.ID_SECCION));
    }
  
    return item;
  });
  
  return { rows: parentRows, selection: selection, expandedGroup: allGroups }
  
}

formatOptativeRows = (rows, idElectiva)=>{
  
  const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente); 
  let _rows = rows.filter(x => x.CHECKED === 0 || String(x.ID_SECCION).split("-")[0] !== String(rowChecked.ID_SECCION) || x.ID_ESTADO_MODALIDAD === 2); 

  let parentRows = _rows.filter(x => (x.HDR === 1));
  
  parentRows.map((item, index)=>{ 
  
    item.TREE = _rows.filter(x => x.CODIGO_CURSO === item.CODIGO_CURSO && x.HDR === 0);
  
    return item;
  });
  
  let selection = this.state.selectionOferta; 
         
  _rows.map((item, index)=>{
    item.ID_SECCION = String(item.ID_SECCION) + "-" + idElectiva;
            
     if (item.CHECKED && (item.HDR === 1 || item.OPTATIVA === 1))
     {
       selection.push(String(item.ID_SECCION));
     }
  
     return item;
  });
  
  return { rows: parentRows, selection: selection }
  
}

setOptativas = (current_rows, rows_optativas, id_seccion)=>{
   
  this.reducerRows.dispatch({
        type: "SET_OPTATIVAS",
        current_rows: current_rows,
        rows_optativas: rows_optativas,
        id_seccion: id_seccion
     });

}

setNuevaSeccion = (current_rows, new_row, id_seccion_cliente)=>{

this.reducerRowsNew.dispatch({
    type: "SET_NUEVA_SECCION",
    current_rows: current_rows,
    new_row: new_row,
    id_seccion_cliente: id_seccion_cliente
 });

}

formatRowsMain = (rows)=>{

let rowsParent = rows.filter(x => x.ESTATUS_FINANCIERO === "P");
let childRow = null;
let childCoRow = null;

rowsParent.map((item)=>{
  if (item.ID_SECCION_CLIENTE_NUEVA !== 0){
    childRow = rows.find(x => x.ID_SECCION_CLIENTE === item.ID_SECCION_CLIENTE_NUEVA);
    item.TREE = [{ ROOT_TREE: "NEW", ...childRow}];

    if (childRow.ID_SECCION_CLIENTE_CORREQUISITO !== null){
     childCoRow = rows.find(x => x.ID_SECCION_CLIENTE === childRow.ID_SECCION_CLIENTE_CORREQUISITO);
      item.TREE = item.TREE.concat([{ ROOT_TREE: "NEW", ...childCoRow }]);
     } 
  }

  return item;
});

return rowsParent;

}

changeExpandedRowIds = expandedRowIds =>{ 
  this.setState({ expandedRowIds });
}

changeExpandedRowIdsOferta = expandedRowIdsOferta => {
  
  const row = funciones.getIdRowChecking(expandedRowIdsOferta, this.state.expandedRowIdsOferta).split("-"); 
  const haveOptativas =  this.state.rowsOferta.find(x => String(x.ID_SECCION) === row[0]); 

  if (this.electivasOpens.find(x => x === row[0]) || haveOptativas === undefined || haveOptativas.OPTATIVA === 0){  
    return this.setState({ expandedRowIdsOferta });
  } 
  
  this.electivasOpens.push(row[0]); 
  this.setState({ expandedRowIdsOferta,  openBackDropInvisible: true }, ()=>{
  
   new Request
  .get(`${globales.ip}/cambios/optativas/${this.cuenta}/${parseInt(row[0])}/${tokenInfo.sucursal}/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 40000, deadline: 40000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
        
        this.electivasOpens = this.electivasOpens.filter(x => x !== row[0]);
        this.setState({ expandedRowIdsOferta: this.state.expandedRowIdsOferta.filter(x => x !== row[0]), 
                        openBackDropInvisible: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
        
       return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0)
     {  
        const infoTable = this.formatOptativeRows(rows, row[0]); 
        this.setOptativas(this.state.rowsOferta, infoTable.rows, row[0]);
        this.setState({ selectionOferta: infoTable.selection, openBackDropInvisible: false });
     }
     else 
     {  
        this.setOptativas(this.state.rowsOferta, null, row[0]);
        this.setState({ openBackDropInvisible: false });
     }            
     
   });

  });

}

handleCloseConfirmation = ()=>{
 this.setState({ openModalConfirmation: false });
}

handleOk = ()=>{

 this.setState({ loadingCheck: true, 
                 openModalConfirmation: false }, ()=>{
     
    let rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente);
    let rowNewChecked = rowChecked.TREE; 
        
    this.gestion_cambio(rowChecked.ID_PLAN, 
                        rowChecked.ID_SECCION, 
                        rowChecked.ES_CORREQUISITO,
                        rowChecked.TIENE_CORREQUISITOS,
                        rowChecked.HIBRIDA,
                        parseFloat(rowChecked.VALOR).toFixed(2), 
                        rowNewChecked[0].ID_PLAN,
                        rowNewChecked[0].ID_SECCION,
                        'null', 
                        0, //es_co_nueva
                        0, //tiene_co_nueva
                        rowNewChecked[0].HIBRIDA,
                        rowNewChecked[0].VALOR,
                        0, //hibrida_co_nueva
                        rowNewChecked[0].ID_DETALLE_PLAN_OPTATIVA,
                        2)
    .then((res)=>{

    if (res === null){
    return; 
    } 

    if (res[0].RESP === 'OK'){ 
      
      let rows = this.state.rows.map((item)=>{
        if (item.ID_SECCION_CLIENTE === this.id_seccion_cliente){
          item.TREE = null;
        }
        return item;
      });
  
      let selection = this.state.selection.filter(x => x !== this.id_seccion_cliente);
      let expandedRowIds = this.state.expandedRowIds.filter(x => x !== this.id_seccion_cliente);
      
      this.setState({ rows,
                      selection,
                      expandedRowIds,
                      loadingCheck: false }, ()=>{
                        funciones.showToast('s', "Se ha reversado el cambio");
                      });

    }
    else{

      this.setState({ loadingCheck: false }, ()=>{ 
        funciones.showToast('w', res[0].RESP);
      });

    } 

 });

});
}

gestion_cambio = async (id_plan, id_seccion, es_co, tiene_co, hibrida, precio, id_plan_nueva, id_seccion_nueva, id_seccion_co_nueva, es_co_nueva, tiene_co_nueva, hibrida_nueva, precio_nuevo, hibrida_co_nueva, id_detalle_plan, tipo)=>{

  return await new Promise(resolve => {
 
   new Request
   .post(`${globales.ip}/cambios`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .set('Content-Type', 'application/json')
   .send({ cuenta_alumno: this.cuenta, 
           id_plan: id_plan,
           id_seccion: id_seccion,
           es_co: es_co,
           tiene_co: tiene_co,
           hibrida: hibrida,
           precio: precio,
           id_plan_nueva: id_plan_nueva,
           id_seccion_nueva: id_seccion_nueva,
           id_seccion_co_nueva: id_seccion_co_nueva,
           es_co_nueva: es_co_nueva,
           tiene_co_nueva: tiene_co_nueva,
           hibrida_nueva: hibrida_nueva,
           precio_nuevo: precio_nuevo,
           hibrida_co_nueva: hibrida_co_nueva,
           id_detalle_plan: id_detalle_plan,
           ad_usuario: tokenInfo.user,
           tipo: tipo,
          })
   .retry(0)
   .timeout({ response: 40000, deadline: 40000, }) 
   .end((err, res) => {
           
     if (err) { 
   
         if (err.toString().substr(0,16) === 'Error: Forbidden')
         {
               
           window.location.reload();
           return;
                 
         }
   
         this.setState({ loadingCheck: false, loadingCheckSecondary: false }, ()=>{  
           funciones.showToast('e', 'No hay conexión'); 
         });
     
         return resolve(null);
     }
         
     const rows = JSON.parse(res.text); 
   
     if (rows.length > 0)
     {  
       resolve(rows);
     }     
     
  });
 
 });
 
}

handleCloseCambio = ()=>{
  this.setState({ openModalCambio: false });
}

rowsCambio = (id_plan, id_seccion_origen, es_co, tiene_co, hibrida, valor, id_plan_nueva, id_seccion_destino, id_seccion_co_destino, es_co_nueva, tiene_co_nueva, hibrida_nueva, valorNuevo, hibrida_co_nueva, id_detalle_plan, descripcionOrigen, descripcionDestino, cargo, total)=>{
 
this.rowsCambioTmp = [
  { KEY: 0, LABEL: "ID_PLAN", VALUE: id_plan, VISIBLE: false},
  { KEY: 1, LABEL: "ID_SECCION_ORIGEN", VALUE: id_seccion_origen, VISIBLE: false},
  { KEY: 2, LABEL: "ES_CO", VALUE: es_co, VISIBLE: false},
  { KEY: 3, LABEL: "TIENE_CO", VALUE: tiene_co, VISIBLE: false},
  { KEY: 4, LABEL: "HIBRIDA", VALUE: hibrida, VISIBLE: false},
  { KEY: 19, LABEL: "PRECIO", VALUE: parseFloat(valor).toFixed(2), VISIBLE: false},
  { KEY: 5, LABEL: "ID_PLAN_NUEVA", VALUE: id_plan_nueva, VISIBLE: false},
  { KEY: 6, LABEL: "ID_SECCION_DESTINO", VALUE: id_seccion_destino, VISIBLE: false},
  { KEY: 7, LABEL: "ID_SECCION_CO_NUEVA", VALUE: id_seccion_co_destino, VISIBLE: false},
  { KEY: 8, LABEL: "ES_CO_NUEVA", VALUE: es_co_nueva, VISIBLE: false},
  { KEY: 9, LABEL: "TIENE_CO_NUEVA", VALUE: tiene_co_nueva, VISIBLE: false},
  { KEY: 10, LABEL: "HIBRIDA_NUEVA", VALUE: hibrida_nueva, VISIBLE: false},
  { KEY: 20, LABEL: "PRECIO_NUEVO", VALUE: parseFloat(valorNuevo).toFixed(2), VISIBLE: false},
  { KEY: 11, LABEL: "HIBRIDA_CO_NUEVA", VALUE: hibrida_co_nueva, VISIBLE: false},
  { KEY: 12, LABEL: "ID_DETALLE_PLAN", VALUE: id_detalle_plan, VISIBLE: false},
  { KEY: 17, LABEL: "Curso actual", VALUE: descripcionOrigen, VISIBLE: true},
  { KEY: 18, LABEL: "Curso nuevo", VALUE: descripcionDestino, VISIBLE: true},
  { KEY: 19, LABEL: "Monto de curso actual", VALUE: funciones.formatCurrency(valor), VISIBLE: true},
  { KEY: 20, LABEL: "Monto de curso nuevo", VALUE: funciones.formatCurrency(valorNuevo), VISIBLE: true},
  { KEY: 21, LABEL: "Diferencia", VALUE: funciones.formatCurrency(parseFloat(valorNuevo).toFixed(2) - parseFloat(valor).toFixed(2)), VISIBLE: true},
  { KEY: 22, LABEL: "Cargo por servicio", VALUE: funciones.formatCurrency(cargo), VISIBLE: true},
  { KEY: 23, LABEL: "Total transacción", VALUE: funciones.formatCurrency(total), VISIBLE: true},
];
const _total=total;
this.setState({ totaldiferencia:_total});


return this.rowsCambioTmp.filter(x => x.VISIBLE);

}

newRowCambio = (id_seccion_cliente, newRow, waiting)=>{

newRow[0].ID_SECCION_CLIENTE = id_seccion_cliente * -1;
if (newRow[1] !== undefined){
  newRow[1].ID_SECCION_CLIENTE = "C" + id_seccion_cliente;
}

if (waiting){
  this.state.expandedRowIds.push(id_seccion_cliente);
  this.state.selection.push(id_seccion_cliente);
  this.setNuevaSeccion(this.state.rows, newRow, id_seccion_cliente);
  return;
}

const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === id_seccion_cliente);
let _rows = this.state.rows.filter(x => x.ID_SECCION_CLIENTE !== id_seccion_cliente);
_rows = _rows.filter(x => x.ID_SECCION_CLIENTE !== rowChecked.ID_SECCION_CLIENTE_CORREQUISITO || (rowChecked.CODIGO_CURSO===newRow[0].CODIGO_CURSO && x.ID_SECCION_CLIENTE === rowChecked.ID_SECCION_CLIENTE_CORREQUISITO));
newRow[0].ROOT_TREE = null;

const rows = _rows.concat(newRow);

this.setState({ rows });

}

handleCambioOk = ()=>{

this.setState({ openModalCambio: false, loadingCheck: true }, ()=>{

this.gestion_cambio(this.rowsCambioTmp[0].VALUE,
                    this.rowsCambioTmp[1].VALUE,
                    this.rowsCambioTmp[2].VALUE,
                    this.rowsCambioTmp[3].VALUE,
                    this.rowsCambioTmp[4].VALUE,
                    this.rowsCambioTmp[5].VALUE,
                    this.rowsCambioTmp[6].VALUE,
                    this.rowsCambioTmp[7].VALUE,
                    this.rowsCambioTmp[8].VALUE,
                    this.rowsCambioTmp[9].VALUE,
                    this.rowsCambioTmp[10].VALUE,
                    this.rowsCambioTmp[11].VALUE,
                    this.rowsCambioTmp[12].VALUE,
                    this.rowsCambioTmp[13].VALUE,
                    this.rowsCambioTmp[14].VALUE,
                    1)
.then((res)=>{
        
  if (res === null){
    return; 
  } 
            
  if (res[0].RESP === undefined){ 

    this.setState({ loadingCheck: false }, ()=>{ 
     this.newRowCambio(this.id_seccion_cliente, res, parseFloat(this.rowsCambioTmp[21].VALUE.replace(",", "")) > 0 ? true : false);
     funciones.showToast('s', "Se ha procesado el cambio");
    });

  }
  else{

    this.setState({ loadingCheck: false }, ()=>{ 
      funciones.showToast('w', res[0].RESP);
    });

  } 
  
});

});
 
}

resetValuesSeccionHibrida=()=>{
  this.baseHibridaTmp=null;
}

resetValuesSeccionHibridaCo = ()=>{
  this.coHibridaTmp=null;
}

setValuesRow = (id_row, disponible, disponible_mod)=>{

  this.state.rowsOferta.map((item)=>{
  
    if (item.TREE !== null)
    {
       item.TREE.map((_item)=>{
          
         if (_item.TREE !== null){
            _item.TREE.map((__item)=>{
              if (String(__item.ID_SECCION) === id_row){  
                
                __item.DISPONIBLE = disponible !== undefined ? disponible : __item.DISPONIBLE;
                __item.DISPONIBLE_MODALIDAD = disponible_mod !== undefined ? disponible_mod : __item.DISPONIBLE_MODALIDAD;
  
              }
              return __item;
            });
         }
  
        if (String(_item.ID_SECCION) === id_row)
        {  
           
           _item.DISPONIBLE = disponible !== undefined ? disponible : _item.DISPONIBLE;
           _item.DISPONIBLE_MODALIDAD = disponible_mod !== undefined ? disponible_mod : _item.DISPONIBLE_MODALIDAD;
         
        }
  
        return _item;
       });
    }
  
    return  item;
  }); 
  
}

setCheckedRowCo = (id_row, disponible, disponible_mod)=>{

 this.state.rowsCo.map((item)=>{
    
  if (String(item.ID_SECCION) === id_row){  
    item.DISPONIBLE = disponible;
    item.DISPONIBLE_MODALIDAD = disponible_mod;
  }
  return item;
 
 });
  
}

onClickListItemOferta = (valueHibrida, idRow) =>{
  
  const infoRow = this.getInfoRowChecked(idRow); 
  this.baseHibridaTmp = (infoRow.AUTONOMA === 2 && valueHibrida === "PRE") ||
                        (infoRow.AUTONOMA === 1 && valueHibrida === "PMV") ? 1 : 0;
  let newSelection = this.state.selectionOferta.concat(idRow); 
  this.changeSelectionOferta(newSelection);
  
}

onClickListItemOfertaCo = (valueHibrida, idRow) =>{

const infoRowCo  = this.state.rowsCo.find(x => x.ID_SECCION === parseInt(idRow)); 
this.coHibridaTmp = (infoRowCo.AUTONOMA === 2 && valueHibrida === "PRE") ||
                     (infoRowCo.AUTONOMA === 1 && valueHibrida === "PMV") ? 1 : 0;
let newSelection = this.state.selectionCo.concat(idRow);
this.changeSelectionCo(newSelection);

}

changeOptionCost = (id_seccion_cliente, free)=> (e)=>{
  
  this.id_seccion_cliente = id_seccion_cliente;

  this.setState({ confirmationTitle: "Cambio sin costo",
                  confirmationText: "¿Confirma que desea " + (free === 1 ? "inhabilitar" : "habilitar") + " cambio sin costo?",
                  openModalConfirmation: true });

}

handleCSCOk = ()=>{

const actionCheck = this.state.confirmationText.includes("inhabilitar") ? 0 : 1;
const rowChecked = this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente);

this.setState({ loadingCheckSecondary: true, openModalConfirmation: false }, ()=>{

 this.gestion_cambio(rowChecked.ID_PLAN, 
                     rowChecked.ID_SECCION, 
                     rowChecked.ES_CORREQUISITO,
                     rowChecked.TIENE_CORREQUISITOS,
                     rowChecked.HIBRIDA,
                     parseFloat(rowChecked.VALOR).toFixed(2),
                     0, 
                     0, 
                     'null', 
                     0, 
                     0, 
                     0, 
                     0, 
                     0, 
                     'null', 
                     actionCheck === 1 ? 4 : 5)
.then((res)=>{

 if (res === null){
  return; 
 }  

 if (res[0].RESP === 'OK')
 {
    let rows = this.state.rows.map((item) => { 
               if(item.ID_SECCION_CLIENTE === this.id_seccion_cliente){
                item.TIENE_SIN_COSTO = actionCheck; 
               } 
              return item; });

    this.setState({ rows, loadingCheckSecondary: false }, ()=>{
      const accionText = actionCheck === 1 ? "habilitó" : "inhabilitó";
      funciones.showToast("s", "Se " + accionText + " cambio sin costo para " + rowChecked.DESCRIPCION_CURSO);
    });
 }
 else
 {
    this.setState({ loadingCheckSecondary: false }, ()=>{
      funciones.showToast('w', res[0].RESP);
    });
 }

});
  
});

}

componentDidMount() { 
  
 tokenInfo = Auth.getProfile(); //Token decodificado
   
 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{ 
        
  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
    this.filtersClientes('-');        
  }
  else if (tokenInfo.plataforma === 2) //Usuario estudiante
  {
    this.setState({ loadingClientes: false });
    this.handleChangeCuenta(null);     
  }
        
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{
    if (!movil && tokenInfo.plataforma === 1) { 
     document.getElementById('Est_Cambios').focus();
     return;
     }
      
      //if (!movil)
   }); 

}); 
               
}

componentWillUnmount() { //Cerrar Subcripciones
  this.unsubscribeRows();
  this.unsubscribeRowsNew();
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                   <Autocomplete
                      id="Est_Cambios" 
                      options={this.state.optionAutocomplete}
                      getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                      style={{ width: movil ? '100%' : '430px' }}
                      renderInput={(params) => <TextField {...params} 
                                                 label="Estudiante"
                                                 variant="outlined"
                                                 onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                 InputProps={{
                                                             ...params.InputProps,
                                                              endAdornment: (
                                                               <React.Fragment>
                                                                 {this.state.loadingClientes ? 
                                                                 <Fade in style={{
                                                                  transitionDelay: '1000ms',
                                                                }} unmountOnExit>
                                                                 <CircularProgress size={18} /> 
                                                                 </Fade>
                                                                 : 
                                                                  this.state.valueAutoComplete === null ?
                                                                   <Tooltip title="Actualizar lista" placement="top">
                                                                   <IconButton style={{ width: 23, height: 23 }} onClick={this.onRefresh}>
                                                                     <RefreshIcon color="primary"/>
                                                                   </IconButton>
                                                                   </Tooltip>
                                                                  : null
                                                                 }
                                                                 {params.InputProps.endAdornment}
                                                                 </React.Fragment>
                                                                 ),
                                                            }}
                                                            fullWidth
                                                            />}
                      renderOption={RenderOption}                               
                      onChange={this.onChangeAutocomplete}
                      open={this.state.openAutoComplete}
                      loading={this.state.loadingClientes}
                      ListboxComponent={virtual.ListboxComponent}
                      value={this.state.valueAutoComplete} 
                      className={classes.textField} 
                      onInputChange={this.onChangeInput}
                      popupIcon={null}
                      PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                              
                      />                            
                   </div>
                </React.Fragment>
              );

             }
             
             if (tokenInfo.plataforma === 2){

              return(
                <React.Fragment>
                 <Paper variant="outlined" className={classes.paperTitle}>
                  <Typography component='span' variant="h6" className="disableTouchOptions">
                   <strong>Cursos disponibles para cambio</strong>
                  </Typography>
                 </Paper> 
                 <div className={classes.divSecondary}/>
                </ React.Fragment>);

             }             
             
            })()

          }
          <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
           <CustomTable 
             Columns={columns} 
             Rows={this.state.rows}
             Grouping={grouping}                      
             TableColumnExtensions={columnExtensions} 
             columnWidths={columnExtensions}
             DefaultHiddenColumnNames={['ID_SECCION_CLIENTE', 'TREE']}
             ExpandedGroups={this.state.expandedGroups}
             ChangeExpandedGroups = {this.changeExpandedGroups}
             getRowId={RowId}
             VirtualTable_cellComponent={VirtualTable_cellComponent(this.changeOptionCost, this.state.loadingCheckSecondary, this.id_seccion_cliente)}
             height={this.state.heightTableMain} 
             loading={this.state.loadingMain}
             enabledFilterRows                    
             rowHeaderCellComponent={HeaderRowCellComponent}
             filterCellComponent={FilterCellComponent}
             TableNameTreeColum='ROOT_TREE'
             GetChildRows={ChildRows}
             TableTreeColumn_cellComponent= {TableTreeColumn_cellComponent(this.state.loadingCheck, this.id_seccion_cliente, classes.tooltip, this.state.openModal, this.state.openModalCo)}
             showSelectionControlsTree
             groupContentComponent={GroupCellContent}                   
             FilteringColumnExtensions = {settingFilter}
             OnExpandedRowIdsChange = {this.changeExpandedRowIds}
             ExpandedRowIds = {this.state.expandedRowIds}
             Selection ={this.state.selection}
             ChangeSelection = {this.changeSelection}    
             leftColumnsFixed={['ROOT_TREE']}
             columnFixedCellComponent = {ColumnFixed_cellComponent}          
             vtRef = {this.vtRef}            
             />                  
             </div>
             <Dialog open= {this.state.openModal}                            
                     TransitionProps={{ onEntering: this.onEntering }} 
                     classes = {{ paper: classes.paper }}
                     fullScreen
                     TransitionComponent={Transition}>
             <DialogTitle><Typography component="span" variant="subtitle2">Oferta de matrícula para cambio</Typography>
               <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                 <CloseIcon fontSize="small" />
               </IconButton>
             </DialogTitle>
             <DialogContent>
              <div ref={this.tablaOfertaRef} className="disableTouchOptions">
              <CustomTable 
                 Columns={columnsOferta} 
                 Rows={this.state.rowsOferta}
                 Grouping={groupingOferta}                      
                 TableColumnExtensions={columnExtensionsOferta} 
                 DefaultHiddenColumnNames={['ID_SECCION', 'ID_PLAN', 'ESTATUS_FINANCIERO', 'GRUPO', 'OPTATIVA', 'TREE']}
                 ExpandedGroups = {this.state.expandedGroupsOferta}
                 ChangeExpandedGroups = {this.changeExpandedGroupsOferta}
                 groupContentComponent={GroupCellContentOferta}
                 getRowId={RowIdOferta}
                 rowHeaderCellComponent={HeaderRowCellComponent}
                 VirtualTable_cellComponent={VirtualTable_cellComponentOferta(classes.tooltip)}
                 height = {this.state.heightTableOferta} 
                 loading= {this.state.loadingOferta} 
                 enabledFilterRows
                 filterCellComponent={FilterCellComponent}
                 TableNameTreeColum='ROOT_TREE'
                 GetChildRows={ChildRows}
                 showSelectionControlsTree
                 OnExpandedRowIdsChange = {this.changeExpandedRowIdsOferta}
                 ExpandedRowIds = {this.state.expandedRowIdsOferta}
                 TableTreeColumn_cellComponent= {tableTreeColumn_cellComponentOferta(this.state.loadingCheck, checkId, classes, this.onClickListItemOferta, this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente))} 
                 leftColumnsFixed={['ROOT_TREE']}
                 columnFixedCellComponent={ColumnFixed_cellComponent}
                 FilteringColumnExtensions={settingFilter}
                 Selection={this.state.selectionOferta}
                 ChangeSelection={this.changeSelectionOferta}
                 columnWidths={columnExtensionsOferta}
                 />                  
               </div>
              </ DialogContent>
               <DialogActions ref={this.dialogActionRef} />
             </Dialog>
                
             <Dialog open= {this.state.openModalCo}                            
                     TransitionProps={{ onEntering: this.onEnteringCo }} 
                     classes = {{ paper: classes.paperCo }}
                     fullScreen={movil}
                     TransitionComponent={Transition}>
              <DialogTitle><Typography component='span' variant='subtitle2'>Oferta de correquisito para cambio</Typography>
               <IconButton className={classes.closeButton} onClick={this.handleCloseCo} size="small">
                 <CloseIcon fontSize="small" />
               </IconButton>
              </DialogTitle>
              <DialogContent >
                <div ref={this.tablaOfertaRef} className="disableTouchOptions">
                  <CustomTable 
                    Columns={columnsCo} 
                    Rows={this.state.rowsCo}
                    DefaultHiddenColumnNames={['ID_SECCION']}
                    loading={this.state.loadingOfertaCo}
                    height = {this.state.heightTableOfertaCo}
                    getRowId={RowIdOferta}
                    showSelectionColumn
                    VirtualTable_cellComponent={VirtualTable_cellComponentOferta(classes.tooltip)}
                    TableColumnExtensions={columnExtensionsCo} 
                    columnWidths={columnExtensionsCo} 
                    leftColumnsFixed={movil ? [TableSelection.COLUMN_TYPE] : undefined}
                    tableSelectionCellComponent= {tableSelectionCellComponent(this.state.loadingCheck, checkIdCo, classes, this.onClickListItemOfertaCo, this.state.rows.find(x => x.ID_SECCION_CLIENTE === this.id_seccion_cliente))}
                    Selection ={this.state.selectionCo}
                    ChangeSelection={this.changeSelectionCo}
                    columnFixedCellComponent={ColumnFixed_cellComponent}
                  /> 
                </div>
              </ DialogContent>
              <DialogActions ref={this.dialogActionRef} />
              </Dialog>

              <Dialog open={this.state.openModalCambio}
                      classes={{ paper: classes.paperCambio }}>
              <DialogTitle><Typography component='span' variant='subtitle2'>Cambiar curso</Typography>
               <IconButton className={classes.closeButton} onClick={this.handleCloseCambio} size="small">
                <CloseIcon fontSize="small" />
               </IconButton>
              </DialogTitle>
              <DialogContent style={{ paddingBottom: 20 }}>
               <Paper className="disableTouchOptions" variant="outlined" style={{ paddingTop: 10, paddingBottom: 10 }}>
               <Grid columns={columnsCambio}
                      rows={this.state.rowsCambio}>
                  <Table height="auto"
                         columnExtensions={columnExtensionsCambio}
                         cellComponent={Table_cellComponentCambio} /> 
                </ Grid> 
               </Paper>
               <p/><center>{this.state.totaldiferencia > 0 ? this.state.nota : undefined }</center> <p/>
              </ DialogContent>
              <DialogActions>
                <BarraBotones botones={this.botones_cambio} />
              </DialogActions>
              </Dialog>

              <Dialog open= {(this.state.loadingCheck || this.state.loadingCheckSecondary) ? false : this.state.openModalConfirmation}
                      classes = {{ paper: classes.paperConfirm }}>
               <DialogTitle><Typography component="span" variant="subtitle2">{this.state.confirmationTitle}</Typography>
                <IconButton className={classes.closeButton} onClick={this.handleCloseConfirmation} size="small">
                   <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent style={{ paddingTop: "20px", textAlign: "center" }}>
               <Typography variant="body1" gutterBottom>                
                {this.state.confirmationText}
               </Typography>    
              </DialogContent>                       
              <DialogActions style={{ marginTop: '20px'}}>
                <BarraBotones botones={this.state.confirmationTitle === "Reversar cambio" ?  this.botones_eliminar : this.botones_opciones_cambios} />
              </DialogActions>
              </Dialog>

              <Backdrop open={this.state.openBackDropInvisible || this.state.loadingClientes || this.state.loadingMain || this.state.loadingOferta || this.state.loadingOfertaCo || this.state.loadingCheck || this.state.loadingCheckSecondary}
                        className={classes.backdrop} 
                        invisible 
                        transitionDuration={0}/>
          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
